import styled from 'styled-components';
import { IonModal } from '@ionic/react';

export const IonModalWrapper = styled(IonModal)`
  .fill {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    align-content: stretch;
    background-color: #000;
    overflow: hidden;
    justify-content: center;
  }
  .fill .img {
    flex: 1 0 auto;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  .spinner-position {
    position: absolute;
    left: 50%;
    top: 50%;
  }

  .video {
    max-width: 100%;
    max-height: 100%;
    background-color: #000;
  }
`;
